<template>

    <div>
        <b-form>

            <b-tabs v-model="activeTabIndex">
                <b-tab title="Info" active>

                    <template v-for="(value, field) in formData">

                        <template v-if="!hideFields(field)">

                            <b-form-group
                                    :key="field"
                                    :label="transformLabel(field)"
                                    :label-for="field"
                            >

                                <multiselect
                                        v-if="field === 'zodiacSign'"
                                        v-model="formData[field]"
                                        :id="field"
                                        :options="zodiacSigns"
                                        label="label"
                                        track-by="label"

                                        v-validate="checkRequired(field)"
                                        :disabled="loading"
                                        :data-vv-name="transformLabel(field)"
                                        :class="{'is-invalid':invalidValue(transformLabel(field))}"
                                />

                                <multiselect
                                        v-else-if="field === 'keywords'"
                                        v-model="formData[field]"
                                        :id="field"
                                        :options="horoscopeKeywords"
                                        label="label"
                                        track-by="label"
                                        :multiple="true"
                                        v-validate="checkRequired(field)"
                                        :disabled="loading"
                                        :data-vv-name="transformLabel(field)"
                                        :class="{'is-invalid':invalidValue(transformLabel(field))}"
                                />

                                <multiselect
                                        v-else-if="field === 'mood'"
                                        v-model="formData[field]"
                                        :id="field"
                                        :options="moods"
                                        label="label"
                                        track-by="label"

                                        v-validate="checkRequired(field)"
                                        :disabled="loading"
                                        :data-vv-name="transformLabel(field)"
                                        :class="{'is-invalid':invalidValue(transformLabel(field))}"
                                />

                                <c-switch
                                        v-else-if="field === 'approved'"
                                        :id="field"
                                        v-model="formData[field]"
                                        color="success"
                                        :disabled="loading"
                                        label
                                />
                                <vue-picker
                                        v-else-if="field === 'predictionDate'"
                                        v-model="date"
                                        id="dateInterval"
                                        :format="config.format"
                                        :range="config.range"
                                        :no-header="true"
                                        :dark="config.dark"
                                        :label="``"
                                        :no-value-to-custom-elem="true"
                                >
                                    <b-form-input
                                            type="text"
                                            autocomplete="off"
                                            :value="date"
                                    />
                                </vue-picker>

                                <b-form-input
                                        v-else
                                        :key="field"
                                        :id="field"
                                        v-validate="checkRequired(field)"
                                        v-model="formData[field]"
                                        :disabled="loading"
                                        :data-vv-name="transformLabel(field)"
                                        :class="{'form-control':true, 'is-invalid':invalidValue(transformLabel(field))}"
                                        type="text"
                                />

                                <b-form-invalid-feedback
                                        :force-show="invalidValue(transformLabel(field))"
                                >
                                    {{ errors.first(transformLabel(field)) }}
                                </b-form-invalid-feedback>

                            </b-form-group>

                        </template>

                    </template>

                </b-tab>

                <b-tab title="Translations">

                    <TranslationForm
                            v-if="translations"
                            :translations="translations"
                            :new-translation-item="newTranslationConstructor"
                            ref="TranslationForm"
                            @validateForm="validateForm"
                    />

                </b-tab>

            </b-tabs>

        </b-form>

    </div>

</template>

<script>
    import arrayToObject from "@/libs/arrayToObject";
    import {removeSymbol} from "@/libs/backend/apimapper";
    import cloneObject from "@/libs/cloneObject";
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import TranslationForm from "@/components/Includes/TranslationForm/TranslationForm.vue";
    import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
    import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
    import Multiselect from 'vue-multiselect';
    import {Switch as cSwitch} from '@coreui/vue';


    export default {
        name: 'HoroscopeDailyForm',
        components: {
            'vue-picker': VueCtkDateTimePicker,
            Multiselect,
            TranslationForm,
            cSwitch
        },
        props: {
            formData: {
                type: Object,
                required: false,
            },
            zodiacSigns: {
                type: Array,
                required: true,
            },
            horoscopeKeywords: {
                type: Array,
                required: true,
            },
            loading: {
                type: Boolean,
                required: true,
            },
            moods: {
                type: Array,
                required: true,
            }
        },
        data() {
            return {
                date: '',
                config: {
                    format: 'YYYY-MM-DD',
                    formatted: 'll',
                    // range: false,
                    onlyDate: true,
                    overlay: true,
                    dark: true
                },
                activeTabIndex: 0,
                newTranslationConstructor: {
                    locale: '',
                    description: ''
                },
                translations: [],
            }
        },
        watch: {
            formData() {
                this.checkData();
                this.getTranslationsData();
                this.defaultTab();
            }
        },
        methods: {
            defaultTab() {
                this.activeTabIndex = 0;
            },

            getTranslationsData() {
                if (this.formData) {
                    const sourceData = Object.values(this.formData.translations);
                    sourceData.filter((attr) => removeSymbol(attr));
                    this.translations = sourceData;
                }
            },

            checkData() {
                if (this.formData) {
                    this.date = this.formData.predictionDate.split(' | ')[0]
                }
            },

            checkRequired(field) {
                const requiredFields = [
                    'predictionDate',
                    'mood',
                    'rating',
                    'intensity',
                    'zodiacSign'
                ];

                const intField = field === 'rating' || field === 'intensity';

                return intField ? 'required|numeric' : (requiredFields.indexOf(field) !== -1 ? 'required' : 'min:1');
            },

            invalidValue(fieldName) {
                return this.$validator.errors.has(fieldName);
            },

            transformData() {
                const horoscopeData = cloneObject(this.formData);
                const prefix = '/api/astrology';

                horoscopeData.mood = `${prefix}/moods/${horoscopeData.mood.value}`;

                horoscopeData.keywords = horoscopeData.keywords.map((keyword) => `${prefix}/horoscope_keywords/${keyword.value}`);

                horoscopeData.rating = Number(horoscopeData.rating);
                horoscopeData.intensity = Number(horoscopeData.intensity);
                horoscopeData.zodiacSign = Number(horoscopeData.zodiacSign.value);
                horoscopeData.predictionDate = `${this.date}T00:00:00`;

                horoscopeData.translations = arrayToObject(this.translations, 'locale');

                return horoscopeData;
            },

            validateForm() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('saveHoroscopeDaily', this.transformData());
                    }
                });
            },

            handleSave() {
                this.$refs.TranslationForm.validateTranslations();
            },

            transformLabel(field) {
                return capitalizeFirstLetter(field);
            },

            hideFields(field) {
                return field === 'id' || field === 'translations';
            }
        },
    }
</script>
<style lang="scss">
    .form-group #deviceId {
        text-transform: uppercase;
    }

    .datepicker.flex.flex-direction-column {
        min-width: auto !important;
        width: auto !important;
    }

    .time-picker.flex.flex-fixed.flex-1.is-dark.with-border {
        display: none;
    }
</style>
